import React from "react";
import "@fluentui/react/dist/css/fabric.css";
import "../../styles/dashboard/layout.css";
import { initializeIcons, loadTheme } from "@fluentui/react";
import themesettings from "./theme-config";

function WithTheme(props) {
  initializeIcons();
  loadTheme(themesettings);
  return <>{props.children}</>;
}

export default WithTheme;
